import once from 'shared-worker-versioning/lib/utils/once';
import { Debugger } from 'calling-cross-tab-library/utils/Debugger';
const CLIENT_DEBUGGER_NAME = 'calling-extensions-cross-tab';
let clientDebugger;
export const getCrossTabDebugger = once(() => {
  try {
    if (clientDebugger) return clientDebugger.log;
    clientDebugger = new Debugger(`${CLIENT_DEBUGGER_NAME}`);
    return clientDebugger.log;
  } catch (e) {
    // nothing to see here.
  }
  return undefined;
});
export const logDebugMessage = (...args) => {
  const debug = getCrossTabDebugger();
  if (debug) debug(...args);
};
export const logDebugMessageOnce = once((...args) => {
  logDebugMessage(...args);
});